import * as z from "zod/v4";

const AccountingConnectionSchema_ = z.object({
  id: z.bigint(),
  accountId: z.bigint(),
  platform: z.string(),
  integrationId: z.string(),
  syncEnabled: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const getAccountingConnections = {
  name: "getAccountingConnections" as const,
  input: z.null(),
  output: z.object({ connections: z.array(AccountingConnectionSchema_) }),
};
